import { autocompleteClasses } from "@mui/material";
const MuiAutocomplete = {
    styleOverrides: {
        listbox: ({ theme })=>({
                [`& .${autocompleteClasses.option}[aria-selected="true"]`]: {
                    backgroundColor: theme.palette.action.menuSelected
                }
            }),
        tagSizeMedium: {
            height: '18px',
            margin: '2px',
            ["& .MuiChip-labelMedium"]: {
                fontSize: '12px',
                padding: '0 8px'
            },
            ["& .MuiSvgIcon-fontSizeMedium"]: {
                width: '16px',
                height: '16px',
                marginLeft: '-4px'
            }
        }
    }
};
export { MuiAutocomplete };

//# sourceMappingURL=multiselect-overrides.js.map